/**
 *
 * Organizations/Show/Campaigns/Table
 *
 */

import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import EventsTable from 'components/Organizations/Show/Events/SubTable'
import AppointmentsTable from 'components/Organizations/Show/Appointments/Table'
import ReactTable, { dateCell, dateAccessor } from 'components/ReactTable'

function CampaignsTable({ campaigns, loading }) {
	const columns = [
		{
			Header: 'Campaign',
			accessor: (c) => `${c.name} ${c.headline}`,
			Cell: ({ row: { original: c } }) => (
				<div style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
					<Link to={`/campaigns/${c.id}`}>
						{c.name}
						<br />
						{c.headline}
					</Link>
				</div>
			),
			width: 220,
		},
		{
			Header: 'Advisor',
			accessor: (c) => c.user.full_name,
		},
		{
			Header: 'Topic',
			accessor: 'topic_name',
			width: 110,
			className: 'text-center',
		},
		{
			Header: 'Objective',
			accessor: 'objective',
			width: 100,
			className: 'text-center',
		},
		{
			Header: 'Registrations',
			accessor: 'total_registrations_count',
			width: 80,
			className: 'text-center',
			disableFilterBy: true,
		},
		{
			Header: 'Last updated',
			id: 'updated_at',
			Cell: dateCell,
			accessor: dateAccessor('updated_at'),
			width: 100,
			sortType: 'datetime',
		},
		{
			// expander column
			Header: '',
			id: 'expander',
			width: 70,
			Cell: ({ row }) => (
				<div className="btn btn-secondary btn-sm rounded" {...row.getToggleRowExpandedProps()}>
					{row.isExpanded ? 'Hide' : 'View'}
				</div>
			),
			className: 'expander-column',
		},
	]

	return (
		<ReactTable
			columns={columns}
			data={campaigns}
			SubComponent={SubComponent}
			defaultSortBy={[{ id: 'updated_at', desc: true }]}
			noDataText="No Campaigns found"
			loading={loading}
		/>
	)
}

function SubComponent({ row: { original: campaign } }) {
	return (
		<div className="sub-component">
			{campaign.objective === 'Events' && (
				<EventsTable events={campaign.events} hide_pagination_component is_subcomponent />
			)}
			{campaign.appointments?.length > 0 && (
				<AppointmentsTable appointments={campaign.appointments} hide_pagination_component is_subcomponent />
			)}
		</div>
	)
}

CampaignsTable.propTypes = {}

export default memo(CampaignsTable)
